import { RestrictedAccountObjectFacade } from "../restricted-account-object/restricted-account-object.facade";
import { ReportLayout } from "./report-layout.model";
import { ReportLayoutApiFacade } from "./report-layout.api-facade";
import { ReportLayoutStoreFacade } from "./report-layout.store-facade";

export class ReportLayoutFacade extends RestrictedAccountObjectFacade<ReportLayout, ReportLayoutApiFacade, ReportLayoutStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/report-layout/report-layout.facade.ts